import { AppRoute } from "modules/routing/types/AppRoute";
import { IssuesList } from "../pages/IssuesList/IssuesList";
import { ViewAmmendIssue } from "../pages/ViewAmmendIssue/ViewAmmendIssue";

export const issuesManagementHome = '/issue';

export const viewAmmendIssueRoute = (id?: string): string => {
    return `/issue/${id ?? ':id'}`
}

export const issuesManagementRoutes: AppRoute[] = [
    {
        name: 'Issues Management List Home',
        path: issuesManagementHome,
        exact: true,
        component: IssuesList
    },
    {
        name: 'View/Ammend Issue',
        path: viewAmmendIssueRoute(),
        exact: true,
        component: ViewAmmendIssue
    }
];